// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2-pNp","productName":"Table_productName__ar6UQ"};